import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { ComercialModel } from '../../models/comercial/comercial.model';

export class GetUsersUseCase implements UseCase<void, ComercialModel> {
  constructor(private configRepository: ConfigurationRepository) {}
  execute(): Observable<ComercialModel> {
    return this.configRepository.getUsers();
  }
}
